export default {
  components: {},
  props: {
    showRightIcon: {
      type: Boolean,
      default: false
    },
    leftIcon: {
      type: String,
      default: ''
    },
    // 是否为三方查看更多跳转
    isThirdMore: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  methods: {
    /**
     * tag点击事件，跳转具体的tag对应poi详情页/展开poi列表
     */
    handelClick() {
      this.$emit('poi-click');
    }
  }
};